<template>
  <div class="checkout-navigation" :class="{'fixed': $props.fixed}">
    <div class="inner-content">
      <base-button variant="secondary" @click="$emit('back')">{{ $t('common.back') }}</base-button>
      <base-button variant="primary" @click="$emit('continue')" :disabled="isContinueButtonDisabled">
        {{ $t('common.continueForward') }}
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/base-button'
import { customEvent } from '@/services/customEventBus'

export default {
  name: 'checkout-navigation-buttons',
  components: { BaseButton },
  props: {
    fixed: Boolean
  },
  data () {
    return {
      isContinueButtonDisabled: false
    }
  },
  mounted () {
    customEvent.$on('disable-co-continue-button', () => { this.isContinueButtonDisabled = true })
  },
  destroyed () {
    customEvent.$off('disable-co-continue-button')
  }
}
</script>

<style scoped lang="scss">
.checkout-navigation {
  width: 100%;
  background-color: $white;
  border-top: 1px solid $border-color;
  z-index: 2;

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .inner-content {
    max-width: 1000px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.6rem;
    padding: 2.4rem 1.6rem;

    @media (map_get($breakpoints, md)) {
      padding: 2.4rem 0;
    }

    /deep/ .base-button {
      min-width: auto;
      flex: 1 1 50%;

      @media (map_get($breakpoints, sm)) {
        min-width: 180px;
        flex: 0 0 auto;
      }
    }
  }
}
</style>
